<div class="modal-header bg-simyo-grey">
    <div class="w-100 text-center">
        <h5 class="commissions-modal-title white">Aviso importante</h5>
    </div>
    <!-- <button type="button" class="close" (click)="closeModal()">
        <span aria-hidden="true"><img src="./assets/img/times2.svg" class="img-fluid ico-title" width="20"></span>
    </button> -->
</div>

<div class="modal-body pt-0">
    <div class="m-4 row">
        <p class="main-text-1 mb-0 mt-2">Es necesario que firmes el nuevo contrato.</p>
        <p class="main-text-2">Te enviaremos un enlace a tu email para completar la firma.</p>

        <div class="row mt-3">
            <div class="col-12">
                <div class="email-container">
                    <div>Email de contacto:</div>
                    <div class="ms-3"><strong>{{ pdv.info.email }}</strong></div>
                </div>
                </div>
                <div class="col-12">
                <span class="wrong-email-text">
                    Si el email de contacto no es correcto contacta con tu GPV.
                </span>
            </div>
        </div>

        <div class="w-100 d-flex justify-content-end mb-2" style="gap: 16px;">
            <a class="btn btn-black--outline ps-4 pe-4 font-button" (click)="checkDocumentsSignature()" *ngIf="hasSentCommissions || isSignatureRequestActive || docsSignedPendingCheck"
            [class.disabled]="isCheckingSignature || documentsSignedSuccess"
            [attr.aria-disabled]="isCheckingSignature || documentsSignedSuccess">
                <strong>{{ isCheckingSignature ? 'Comprobando...' : documentsSignedSuccess ? 'Firma completada' : 'Comprobar estado de la firma' }}</strong>
            </a>
            <a class="btn btn-black--outline ps-4 pe-4 font-button reenviar-button" (click)="sendCommissionsLink()"
            [class.disabled]="isSendingCommissions || hasSentCommissions || docsSignedPendingCheck || ((!canResend && isSignatureRequestActive)) || isCheckingSignature || documentsSignedSuccess">
                <strong>{{ hasSentCommissions ? 'Enviado' : isSendingCommissions ? 'Enviando...' : (isSignatureRequestActive || docsSignedPendingCheck) ? 'Reenviar' : 'Enviar' }}</strong>
            </a>
        </div>
        <div class="w-100 d-flex mb-2 docs-signature-pending-alert" style="gap: 16px;" *ngIf="docsSignaturePending">
            <ngb-alert type="warning" [dismissible]="false" class="d-flex align-items-center">
                <img src="./assets/img/info_black.svg" class="my-auto" width="16">
                <span style="font-size: 14px;">
                    Documentos pendientes de firma. Por favor, revisa la bandeja de entrada de tu email para completar la firma.
                </span>
            </ngb-alert>
        </div>
        <div class="w-100 d-flex mb-2" style="gap: 16px;" *ngIf="isSignatureRequestActive && !docsSignaturePending && !documentsSignedSuccess">
            <ngb-alert type="info" [dismissible]="false" class="d-flex align-items-center" style="width: 100%; gap: 4px; padding: 8px; border-radius: 4px;">
                <img src="./assets/img/info_black.svg" class="my-auto" width="16">
                <span style="font-size: 14px;">
                    Recuerda que una vez firmados los documentos, debes volver a esta pantalla y hacer click en el botón <strong><em>Comprobar estado de la firma</em></strong>.
                </span>
            </ngb-alert>
        </div>
        <p *ngIf="errorMessage" class="text-danger mt-2" style="font-size: 12px;">{{ errorMessage }}</p>
    </div>
</div>
